(function () {
  'use strict';

  angular
      .module('tfc.Products')
      .controller('UploadButtonCtrl', UploadButtonCtrl)
      .directive('tfcUploadButton', tfcUploadButton);

  // @ngInject
  function UploadButtonCtrl($state, Upload, ProductMgr, Toast, $stateParams) {
    var vm = this;

    vm.onChange = function (invalidFiles) {
      if (!_.isEmpty(vm.upload.files) && _.isEmpty(invalidFiles)) {
        ProductMgr.upload(vm.upload.files, $stateParams.brandKey).then(function () {
          Toast.success('files.publish.success');
          $state.reload();
        }, function (response) {
          if (response.status === 409) {
            Toast.error('files.publish.duplicate', { state : true });
          }
          else {
            Toast.error("Site.Error.General");
          }
        })
      } else {
        errorSizeLimitToast(invalidFiles);
      }
    };

    function errorSizeLimitToast(invalidFiles){
      invalidFiles.map(function (file) {
        Toast.error("Sorry, there is a maximum file upload size of 8mb: "+ file.name + " exceeds limit", { state : true });
      });
    }

  }

  // @ngInject
  function tfcUploadButton() {
    return {
      bindToController : true,
      controller : 'UploadButtonCtrl as vm',
      templateUrl : 'Products/UploadButton.tmpl.html',
      scope: {
        vm: '='
      }
    };
  }

})();
